import { html } from "lit";
import { PrefillData } from "../src/api/publicApi/createCase";

export interface SharedCreateServiceCaseProps {
    /**
     * Offers a file upload in the form
     */
    fileUpload?: boolean;
    /**
     * Locale for the form
     */
    locale?: string;
    /**
     * data that should be prefilled in the form
     */
    prefillData?: PrefillData;
    /**
     * Environment for the form
     * @default "prod"
     */
    env?: string;
    /**
     * Use the legacy API
     * @default false
     */
    legacyApi?: boolean;
}

export interface CreateServiceCaseProps extends SharedCreateServiceCaseProps {
    /**
     * Should be displayed as multi-step form
     */
    multipleSteps?: boolean;
    /**
     * Event when the case is created
     */
    onMfServiceCaseSubmit?: () => void;
    /**
     * Event when the case is canceled
     */
    onMfServiceCaseCancel?: () => void;
    /**
     * disable silent auth - in that case the token must be provided via @trumpf/ux.utils
     */
    disableSilentAuth?: boolean;
}
/**
 * CreateServiceCase Form Micro Frontend
 */
export const CreateServiceCase = ({
    multipleSteps,
    fileUpload,
    locale,
    prefillData,
    onMfServiceCaseSubmit,
    onMfServiceCaseCancel,
    disableSilentAuth,
    env,
    legacyApi
}: CreateServiceCaseProps) => {
    return html`
        <mf-create-service-case
            locale="${locale}"
            .prefillData="${prefillData}"
            ?multiple-steps=${multipleSteps}
            ?file-upload=${fileUpload}
            @mfServiceCaseSubmit="${onMfServiceCaseSubmit}"
            @mfServiceCaseCancel="${onMfServiceCaseCancel}"
            env="${env}"
            ?legacy-api=${legacyApi}
            ?disable-silent-auth=${disableSilentAuth}
        >
            <ux-f-sis-create-case-connector slot="connector"></ux-f-sis-create-case-connector>
        </mf-create-service-case>
    `;
};

export interface CreateServiceCaseModalProps extends SharedCreateServiceCaseProps {
    modalName?: string;
}

export const CreateServiceCaseModal = ({
    locale,
    fileUpload,
    prefillData,
    env,
    legacyApi,
    modalName
}: CreateServiceCaseModalProps) => {
    return html`
        <div>
            <button data-trigger-modal=${`open,${modalName}`}>Open Modal</button>
            <mf-create-service-case-modal
                locale="${locale}"
                .prefillData="${prefillData}"
                ?file-upload=${fileUpload}
                env="${env}"
                ?legacy-api=${legacyApi}
                modal-name="${modalName}"
            >
                <ux-f-sis-create-case-connector slot="connector"></ux-f-sis-create-case-connector>
            </mf-create-service-case-modal>
        </div>
    `;
};
